import styled from "styled-components";
import { Row } from "react-bootstrap";
import { Skeleton } from "@mui/material";

export const Wrapper = styled.section`
  display: grid;
  grid-template-columns: auto auto;
  gap: 20px;
  justify-content: center;
  @media screen and (max-width: 576px) {
    grid-template-columns: auto;
    align-content: start;
  }
  .personal-card-payment {
    background: var(--tertiary-color);
    color: var(--white-color);
    @media screen and (max-width: 576px) {
      width: 140px;
      height: 160px;
    }
    .before-discount,
    .after-discount,
    .currency-price,
    h3 {
      color: var(--white-color);
      @media screen and (max-width: 576px) {
        font-size: var(--font-size-xs);
      }
    }
  }
  .roket-style {
    @media screen and (max-width: 576px) {
      width: 75%;
    }
  }
  .submit-payment-button {
    box-shadow: var(--box-shadow1);
    &:disabled {
      box-shadow: none;
    }
  }
  h2 {
    font-weight: 500;
    font-size: var(--font-size-lg);
    color: var(--blue-color-dark);
  }
`;
export const PurchaseInformation = styled.section`
  width: 400px;
  min-height: 340px;
  border: 1px solid var(--primary-color);
  border-radius: 10px;
  @media screen and (max-width: 700px) {
    min-height: 370px;
    width: auto;
  }
  @media screen and (max-width: 576px) {
    height: auto;
    width: 100%;
  }
  h2 {
    @media screen and (max-width: 400px) {
      font-size: var(--font-size-xs);
    }
  }
  h3 {
    font-weight: 500;
    font-size: var(--font-size-base);
    color: var(--primary-color);
    @media screen and (max-width: 400px) {
      font-size: var(--font-size-xs);
    }
  }
  .discount-form-wrapper {
    width: 95%;
    display: grid;
    grid-template-columns: auto auto auto;
    gap: 7px;
    justify-content: center;
    align-items: center;
    @media screen and (max-width: 700px) {
      grid-template-columns: auto auto;
    }
  }
  .discount-input {
    width: 120px;
    border: 0.5px solid var(--tertiary-color);
    border-radius: 6px;
    color: #1c3542;
  }
  .form-control:disabled {
    opacity: 0.7;
    border-radius: 0px;
  }
  label {
    font-size: 10px;
    font-weight: 300;
    color: #1c3542;
    margin: 0px;
    @media screen and (max-width: 700px) {
      order: 3;
      text-align: center;
    }
  }
`;
export const StyledWalletData = styled(Row)`
  background-color: var(--button-color-labs);
  border-radius: 10px;
  font-size: var(--font-size-xs);
  .switch-label {
    color: var(--text-color-dark);
  }
  .Wallet-balance {
    color: var(--tertiary-color);
  }
  .wallet-spinner {
    width: 20px;
    height: 20px;
    color: var(--tertiary-color);
  }
  @media screen and (max-width: 576px) {
    svg {
      width: 30px;
      height: 30px;
    }
  }
`;
export const StyledSkeleton = styled(Skeleton)`
  display: grid;
  grid-template-areas: "item-1 item-2 item-3 item-4";
  justify-content: space-evenly;
  align-items: center;
  @media screen and (max-width: 1200px) {
    justify-content: center;
  }
  @media screen and (max-width: 992px) {
    grid-template-areas:
      "item-1 item-2"
      "item-3 item-4";
  }
`;
export const SkeletonWrapper = styled.span`
  display: grid;
  grid-template-rows: "auto auto auto";
  grid-template-columns: "auto";
  justify-content: space-evenly;
  align-content: center;
  gap: 10px;
`;
